export const PRODUCTS = [
  {
    id: "thca",
    index: "01",
    name: "THCA Small Buds",
    category: "Premium THCA Flower",
    tagline: "Small buds. Full spectrum. Loud results.",
    description:
      "Hand-trimmed, lab-tested THCA small buds delivering top-shelf potency at a fraction of the price. Discreet, fast, dialed-in.",
    image: "/thca-full.jpg?v=2",
    fullImage: true,
    href: "https://thcasmallbuds.com/?ref=420710Always",
    testId: "thca-referral-link",
  },
  {
    id: "rigs",
    index: "02",
    name: "Electric Rigs",
    category: "Electric Dab Rigs & E-Rigs",
    tagline: "Instant heat. Pure flavor. No torch.",
    description:
      "Next-gen electric rigs and vaporizers engineered for consistent, flavorful sessions. Sleek hardware built to last.",
    image: "/bomb-aerix.jpg?v=2",
    fullImage: true,
    href: "https://bombofficial.com/?ref=wewenzwz",
    testId: "rigs-referral-link",
  },
  {
    id: "dubby",
    index: "03",
    name: "Dubby",
    category: "Gaming Energy Drink",
    tagline: "Fuel the grind. Zero crash, all clarity.",
    description:
      "Precision energy engineered for gamers and creators. Clean caffeine, focus nootropics, and flavors that hit different.",
    image: "/dubby.jpg?v=2",
    fullImage: true,
    href: "https://www.dubby.gg/discount/DUBSnDUBBY?ref=RkHkrGL4XOE91C",
    testId: "dubby-referral-link",
  },
];
